import { render, staticRenderFns } from "./QcqCompetence.vue?vue&type=template&id=56816706&scoped=true&lang=pug&"
import script from "./QcqCompetence.vue?vue&type=script&lang=ts&"
export * from "./QcqCompetence.vue?vue&type=script&lang=ts&"
import style0 from "./QcqCompetence.vue?vue&type=style&index=0&id=56816706&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56816706",
  null
  
)

export default component.exports